import { jsx as _jsx } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
var DESKTOP_IMAGE = function(strictLocalize) {
    return IImage.build({
        url: "https://cdn.faire.com/fastly/11d4f8229e746500502c8418be3ecde6b84c528d82fd028dd3a4de71422ee76e.png",
        width: 1280,
        alt_text: strictLocalize({
            id: "Ny1IvN",
            defaultMessage: [
                {
                    type: 0,
                    value: "People chatting in a Faire office"
                }
            ]
        })
    });
};
var TABLET_IMAGE = function(strictLocalize) {
    return IImage.build({
        url: "https://cdn.faire.com/fastly/f700fbd391d842e2ae1cb9e7b496181c2efc34ac8be4a94e2efc873d7a1326d0.png",
        width: 768,
        alt_text: strictLocalize({
            id: "Ny1IvN",
            defaultMessage: [
                {
                    type: 0,
                    value: "People chatting in a Faire office"
                }
            ]
        })
    });
};
var MOBILE_IMAGE = function(strictLocalize) {
    return IImage.build({
        url: "https://cdn.faire.com/fastly/3869318619d5f5c68c21822a317d4bc83f6f649bdba8dfac0e7fc9667e328491.png",
        width: 375,
        alt_text: strictLocalize({
            id: "Ny1IvN",
            defaultMessage: [
                {
                    type: 0,
                    value: "People chatting in a Faire office"
                }
            ]
        })
    });
};
var BelongingPageLargeImageBase = function(strictLocalize) {
    var image = useResponsiveValue({
        mobileAndAbove: MOBILE_IMAGE(strictLocalize),
        tabletAndAbove: TABLET_IMAGE(strictLocalize),
        desktopAndAbove: DESKTOP_IMAGE(strictLocalize)
    });
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(BackgroundColorWrapper, {
        children: /*#__PURE__*/ _jsx(ImageFixedWidth, {
            "data-test-id": "BelongingLargeImage",
            src: optimizeImageUrl(image, isSSR, {
                width: image.width
            })
        })
    });
};
export var BelongingPageLargeImage = function(strictLocalize) {
    return observer(function() {
        return BelongingPageLargeImageBase(strictLocalize);
    });
};
var BackgroundColorWrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-22b9d5e8-0"
})([
    "",
    "{background:linear-gradient( to bottom,",
    " 0%,",
    " 50%,",
    " 50%,",
    " 100% );}"
], responsiveMediaQueries.tabletAndAbove, Decorative.tint.neutral, Decorative.tint.neutral, Core.surface.inverse, Core.surface.inverse);
var ImageFixedWidth = styled.img.withConfig({
    componentId: "sc-22b9d5e8-1"
})([
    "width:100%;max-width:1280px;"
]);
